import { render, staticRenderFns } from "./InfectionFormList.vue?vue&type=template&id=c408f298&scoped=true"
import script from "./InfectionFormList.vue?vue&type=script&lang=js"
export * from "./InfectionFormList.vue?vue&type=script&lang=js"
import style0 from "./InfectionFormList.vue?vue&type=style&index=0&id=c408f298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c408f298",
  null
  
)

export default component.exports